import Glide from '@glidejs/glide';

export default {
  inputSelector: '[data-filter-input]',
  selectSelector: '[data-filter-select]',
  formSelector: '[data-bookshop-filter]',
  paginationSelector: '[data-load-more]',
  paginationLinks: [],
  clearSelector: '[data-clear-filter]',
  clearLinks: [],
  slidersSelector: '[data-product-slider]',
  triggerSelector: '[data-expand-trigger]',
  triggers: [],
  inputs: [],
  selects: [],
  form: null,
  request: null,

  init() {
    console.log('loaded bookshop');
    let _this = this;
    _this.inputs = [...document.querySelectorAll( _this.inputSelector )];
    _this.selects = [...document.querySelectorAll( _this.selectSelector )];
    _this.form = document.querySelector(_this.formSelector);
    _this.triggers = [...document.querySelectorAll( _this.triggerSelector )];

    let filters = [..._this.inputs, ..._this.selects];

    _this.bindPaginationLinks();
    _this.bindClearLinks();
    _this.initSliders();

    if ( filters.length ) {

      filters.forEach( el => {

        el.addEventListener('change', function(e) {
          _this.submitForm();
        });

      });
    }

    if (_this.form) {
      _this.form.addEventListener('submit', function(e) {
        e.preventDefault();
        _this.submitForm();
      });
    }

    if ( _this.triggers.length ) {
      _this.triggers.forEach( el => {

        let target = document.querySelector('[data-expand-target="' + el.dataset.expandTrigger + '"]');

        el.addEventListener('click', function(e) {
          e.preventDefault();
          el.classList.toggle('toggled');
          target.classList.toggle('hidden');
        });

        window.addEventListener('resize', function(event) {
          if (window.innerWidth < 768) {
            el.classList.add('toggled');
            target.classList.add('hidden');
          }
        }, true);

        if (window.innerWidth < 768) {
          el.classList.add('toggled');
          target.classList.add('hidden');
        }

      });
    }

  },

  submitForm() {
    let _this = this;
    let data = {};

    _this.inputs.forEach(input => {
      if(input.checked) {
        if(!data[input.name]) {
          data[input.name] = [];
        }
        data[input.name].push(input.value);
      }
    });

    let queryStringValues = [];

    for (var key in data) {
      queryStringValues.push(key + '=' + data[key].join(','));
    }

    let sortBy = document.querySelector('[name="sort"]').value;
    if(sortBy != 'bestSelling') {
      queryStringValues.push('sort=' + sortBy);
    }

    let search = document.querySelector('[name="search"]').value;
    if(search) {
      queryStringValues.push('search=' + search);
    }

    let queryString = queryStringValues.join('&');
    queryString = queryString ? '?' + queryString : '';
    let url = window.SITE_URL + _this.form.dataset.bookshopFilter + queryString;

    _this.getProducts(url);
  },

  bindPaginationLinks() {
    let _this = this;

    _this.paginationLinks = [...document.querySelectorAll(_this.paginationSelector)];

    if ( _this.paginationLinks.length ) {
      _this.paginationLinks.forEach( el => {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          _this.loadMore(this.getAttribute('href'));
        });
      });
    }
  },

  bindClearLinks() {
    let _this = this;

    _this.clearLinks = [...document.querySelectorAll(_this.clearSelector)];

    if ( _this.clearLinks.length ) {
      _this.clearLinks.forEach( el => {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          _this.clearFilter(el);
        });
      });
    }
  },

  getProducts(url) {
    let _this = this;

    let headers = {
      'Content-type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    if(_this.request) {
        _this.request.abort();
    }

    history.replaceState({page:url}, url, url);

    _this.request = _this.httpGet(
      url,
      headers,
      (response) => {

        let responseContainer = document.createElement('div');
        responseContainer.innerHTML = response;
        document.querySelector('[data-active-filters-container]').innerHTML = responseContainer.querySelector('[data-active-filters]').innerHTML;

        let target = document.querySelector('[data-bookshop-filter-target]');
        target.innerHTML = response;
        _this.bindPaginationLinks();
        _this.bindClearLinks();

        let resultsTotal = document.querySelector('[data-total-products]').dataset.totalProducts;
        document.querySelector('[data-results-total]').innerHTML = resultsTotal;
        document.querySelector('[data-active-filters]').remove();
      },
    );
  },

  loadMore(url) {
    let _this = this;

    let headers = {
      'Content-type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    if(_this.request) {
        _this.request.abort();
    }

    _this.request = _this.httpGet(
      url,
      headers,
      (response) => {
        let target = document.querySelector('[data-products-container]');
        let currentProducts = target.innerHTML;
        let responseContainer = document.createElement('div');
        responseContainer.innerHTML = response;
        let newProducts = responseContainer.querySelector('[data-products-container]');
        target.innerHTML = currentProducts + newProducts.innerHTML;

        document.querySelector('[data-load-more-container]').innerHTML = responseContainer.querySelector('[data-load-more-container]').innerHTML;

        _this.bindPaginationLinks();
        _this.bindClearLinks();
      },
    );
  },

  clearFilter(el) {
    let _this = this;
    let id = el.dataset.clearFilter;

    if (id == 'all') {
      _this.getProducts(window.SITE_URL + _this.form.dataset.bookshopFilter);
      _this.inputs.forEach( input => {
        input.checked = false;
      });
    }
    else if (id == 'search') {
      document.querySelector('[name="search"]').value = "";
      _this.submitForm();
    }
    else {
      _this.inputs.forEach( input => {

        if (id == input.value) {
          input.click();
        }

      });
    }
  },

  httpGet(url, headers = {}, callback = ()=>{return;}, err = console.error) {
    let request = new XMLHttpRequest();
    request.open('GET', url, true);
    if (Object.keys(headers).length) {
      Object.keys(headers).forEach(key => {
        request.setRequestHeader(key, headers[key]);
      });
    }
    request.onload = () => callback(request.responseText);
    request.onerror = () => err(request);
    request.send();
    return request;
  },

  initSliders() {
    let _this = this;

    _this.sliders = [...document.querySelectorAll(_this.slidersSelector)];

    if ( _this.sliders.length ) {
      _this.sliders.forEach( el => {
        this.glide = new Glide(el, {
          type: 'carousel',
          animationDuration: 500,
          perView: 4,
          gap: 24,
          breakpoints: {
            500: {
              perView: 1
            },
            1100: {
              perView: 2
            }
          }
        }).mount();
      });
    }

  }
};
